/**
 * This is the JS responsible for getting all of the checked boxes on the filter bar
 * and doing the query for them.
 *
 * Initialize this on pages that have filtering by doing this;
 *   $.ADLPropertyFilter().init();
 *
 * The pages must also have the filter bar on them.
 */
(function ($) {
    $.ADLPropertyFilter = function( options ) {
        var adlFilter = {
            options: $.extend({
                'page' : 1, // Current page.
                
                'searchResultsText': 'Showing results for: ',
                
                'paginationDiv': $('.pagination-wrapper'),
                'listingsDiv' : $('#state-property-listings'),
                'filterDiv' : $('.property-filter-bar')
            }, options),

            // Is set to true after an ajax call has been made.
            ajaxStarted: false,

            /////////

            /**
             * Calls AJAX function to return HTML for properties that match the filters that
             * are selected.
             *
             * @param types Property Type checkboxes that are checked.
             * @param counties County checkboxes that are checked.
             * @param cities City checkboxes that are checked.
             * @param states State checkboxes that are checked.
             */
            getProperties: function ( types, counties, cities, states ) {
                var plugin = this;

                adlFilter.doLoading();

                $.when(
                    $.ajax({
                        url: uch_app.ajax_url,
                        type: 'GET',
                        data: {
                            security: uch_app.security,
                            action: 'filter_properties',
                            type_terms: JSON.parse( JSON.stringify(types) ),
                            county_terms: JSON.parse( JSON.stringify(counties) ),
                            cities: JSON.parse( JSON.stringify(cities) ),
                            states: JSON.parse( JSON.stringify(states) ),
                            page: plugin.options.page
                        },
                        dataType: 'json',
                        success: function (result) {
                            console.log('success!');
                        },
                        error: function (error) {
                            console.log(error);
                            console.log('error :( ');
                        }
                    })
                ).done(function (result) {
                    // Update listings & pagination with new data.
                    plugin.options.listingsDiv.html( result.listings );
                    plugin.options.paginationDiv.html( result.pagination );

                    // Reset page number to be ready for new query.
                    plugin.options.page = 1;
                    plugin.doLoading();

                    plugin.ajaxStarted = true;
                    console.log(plugin.ajaxStarted);
                });
            },

            /**
             * Add new item to the results tags div.
             * @param item
             */
            updateTags: function(item) {
                var list = $('#js-search-tags-list');
                $('<li class="label" id="' + item.id + '">' + item.data('name') + '</li>').appendTo(list);
            },

            /**
             * Get page number from pagination div. The page number is stored as a data-num
             * on each pagination bar link.
             * @param element
             * @returns {Number}
             */
            findPageNumber: function(element) {
                return parseInt( element.parent().data('num') );
            },

            /**
             * Toggle loading on listings div.
             */
            doLoading: function() {
                var plugin = this;
                plugin.options.listingsDiv.toggleClass('loading');
            },

            /**
             * Given a name for a set of checkboxes, will return a map of
             * just the checked ones.
             *
             * @param checkboxName Checkbox input name.
             * @returns {*}
             */
            getCheckboxMap: function(checkboxName) {
                var plugin = this;

                return $('input[name="' + checkboxName + '"]:checked').map(function () {
                            plugin.updateTags($(this));
                            return $(this).val();
                        }).get();
            },

            /**
             * Initialize click event for filter bar.
             */
            initFilterBar: function() {
                var plugin = this;
                $('.property-filter-bar input').click( function() {
                   plugin.filterProperties();
                });
            },

            /**
             * Gets the checkboxes that are selected and calls getProperties, so
             * we get the properties based on that.
             *
             * Updates the search tags underneath the filter bar.
             */
            filterProperties: function() {
                var plugin = this;
                var type;
                var county;
                var city;
                var state;

                // Remove and replace the search tags div.
                $('#js-search-tags').remove();
                plugin.options.filterDiv.after('<div id="js-search-tags"><strong>' + plugin.options.searchResultsText + '</strong><ul id="js-search-tags-list" class="menu"></ul></div>');

                // Get checkbox maps.
                type = plugin.getCheckboxMap('filter_type');
                county = plugin.getCheckboxMap('filter_county');
                state = plugin.getCheckboxMap('filter_state');
                city = plugin.getCheckboxMap('filter_city');

                // Get properties based on checked boxes.
                plugin.getProperties(type, county, city, state);
            },

            /**
             * Inits AJAX pagination after an initial AJAX call has been made.
             */
            initPagination: function() {
                var plugin = this;

                $(document).on( 'click', '.pagination-wrapper a', function( event ) {
                    // Only do AJAX pagination if an AJAX call has already been made. (i.e. The user has used the filter bar.)
                    console.log('pagination');
                    console.log(plugin.ajaxStarted);
                    if ( plugin.ajaxStarted ) {
                        event.preventDefault();

                        // Get page number from pagination.
                        plugin.options.page = plugin.findPageNumber( $(this) );
                        console.log( plugin.options.page );

                        plugin.filterProperties();
                    }
                });
            }
        };

        // Publicly available functions.
        return {
            init: function() {
                // Init filter bar.
                adlFilter.initFilterBar();

                // Set up pagination calls.
                adlFilter.initPagination();
            }
        };
    };
})(jQuery);